const frontendPort = 8000;
const websocketPort = 3100;
const backendPort = 3105;

const backendUrl = `https://hml.api.noc-ops.mtnw.com.br`;
const backendSocket = `wss://hml.api.noc-ops.mtnw.com.br/ws`;
const frontendUrl = `https://hml.noc-ops.mtnw.com.br`;

const metroCompanyId = 13;

export {
    backendPort,
    frontendPort,
    backendUrl,
    frontendUrl,
    websocketPort,
    backendSocket,
    metroCompanyId
  };
